import axios from 'axios';
import Select2 from 'v-select2-component';
import { strict } from 'assert';

export default {
    components: {
        'select2': Select2
    },
    name: 'SelectWorkTypes',
    props: {
        value: [Number, String, Array],
        inputclass: {
            type: String,
            default: ''
        },
        emptyname: {
            type: String,
            default: null
        },
        includeInactive: {
            type: Boolean,
            default: false
        },
        action: {
            type: String,
            default: null
        },
        url: {
            type: String,
            default: ''
        },
        tags: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        validate: {
            type: String,
            default: ''
        },
        listdata: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            list: []
        };
    },
    computed: {
        
        options() {
            let result = [];
            result.push({ id: 0, text: 'Kiezen' });
            let lastgroupName = null;
            this.list.forEach(decl => {
                if (lastgroupName != decl.workTypeGroup.description) {
                    lastgroupName = decl.workTypeGroup.description;
                    result.push({ text: decl.workTypeGroup.description, children: [] });
                }
                let item = result.filter(x => x.text == decl.workTypeGroup.description)[0];
                item.children.push({ id: decl.id, text: decl.name });
            });
            return result;
        },
    },
    created() {
        this.fetch();
    },
    watch: {
        url() {
            this.fetch();
        }
    },
    methods: {
        fetch() {
            if (this.url != '') {
                let requesturl = APIURL + this.url;
                axios.get(requesturl)
                    .then(resp => {
                        this.list = resp.data;                     
                        
                        if (this.value != null && typeof this.value === "object" && this.value.length > 0) {
                            this.addOptions();
                        }
                    });
            }
            else if (this.listdata != null && this.listdata.length > 0) {
                this.list = this.listdata;
            }

        },
        addOptions() {
            let items = this.list.map(s => s.id.toString());
            let notexisting = this.value.filter(s => !items.includes(s.toString()));
            if (notexisting.length > 0) {
                notexisting.forEach(s => {
                    this.list.push({
                        id: s,
                        name: s
                    });
                });

            }

        }
    }
};